// flag บอก LIFF ปลายทางว่าต้อง pair ผู้ใช้กับ channel นี้ก่อนเข้าหน้าแรก
const CHANNEL_PAIR_QUERY_KEY = "pair_channel";
const CHANNEL_PAIR_QUERY_VALUE = "1";

export function appendChannelPairFlag(url) {
  const nextUrl = new URL(url);
  nextUrl.searchParams.set(CHANNEL_PAIR_QUERY_KEY, CHANNEL_PAIR_QUERY_VALUE);
  return nextUrl.toString();
}

// เปิดผ่าน liff.line.me พารามิเตอร์อาจยังถูกห่ออยู่ใน liff.state
export function hasChannelPairFlag(query) {
  if (query[CHANNEL_PAIR_QUERY_KEY] === CHANNEL_PAIR_QUERY_VALUE) return true;

  const liffStateQuery = String(query["liff.state"] || "").split("?")[1] || "";
  return (
    new URLSearchParams(liffStateQuery).get(CHANNEL_PAIR_QUERY_KEY) ===
    CHANNEL_PAIR_QUERY_VALUE
  );
}

export function hasChannelPairQuery(query) {
  return CHANNEL_PAIR_QUERY_KEY in query;
}

export function removeChannelPairQuery(query) {
  const { [CHANNEL_PAIR_QUERY_KEY]: _removed, ...rest } = query;
  return rest;
}
